import { useState } from "react";

import ResendButton from "./ResendButton";
import { VerificationMode } from "../../../types";
import useTimer from "../hooks/useTimer";

const DELAY_SECONDS = 15;

type Props = {
  resendCode: (mode: VerificationMode) => Promise<void>;
};

export default function ResendVerification({ resendCode }: Props) {
  const { time, restartTimer } = useTimer(DELAY_SECONDS);

  const [retries, setRetries] = useState(0);
  const mode = getVerificationMode(retries);

  const resend = async () => {
    await resendCode(mode);
    restartTimer();
    setRetries(retries + 1);
  };

  return <ResendButton time={time} retries={retries} onButtonPress={resend} />;
}

function getVerificationMode(retries: number): VerificationMode {
  switch (retries) {
    case 0:
      return "whatsapp";
    case 1:
    default:
      return "help";
  }
}
